import LOGO from '../assets/images/logo.svg';
import VIEW_SVG from '../assets/images/svg/eye-open.svg';
import VIEW_CLOSE from '../assets/images/svg/eye-close.svg';
import LOGO_BLACK from '../assets/images/logo-black.png';
import LOGO_BLUE from '../assets/images/logo-blue.png';
import CHECK_SVG from '../assets/images/svg/check.svg';
import BROWSER_IMAGE from '../assets/images/Browser.png';
import FACEBOOK_IMAGE from '../assets/images/svg/facebook.svg';
import INSTAGRAM_IMAGE from '../assets/images/svg/insta.svg';
import TWITTER_IMAGE from '../assets/images/svg/twitter.svg';
import LINKEDIN_IMAGE from '../assets/images/svg/linkedin.svg';
import NO_IMAGE from '../assets/images/no-Image.png';
import LONG_ARROW from '../assets/images/svg/long-arrow.svg';
import AVATAR from '../assets/images/avatar.png';
import PLAN_ICON from '../assets/images/plan-icon.png';
import SEARCH_SVG from '../assets/images/svg/Icon-search.svg';
import EMAIL_SVG from '../assets/images/svg/ic16-email.svg';
import HEART_SVG from '../assets/images/svg/ic20-heart-full.svg';
import PROFILE_IMG from '../assets/images/img-01.png';
import PROFILE from '../assets/images/profile.png';
import PROFILE1 from '../assets/images/user-1.png';
import PROFILE2 from '../assets/images/user-2.png';
import PROFILE3 from '../assets/images/user-3.png';
import PROFILE4 from '../assets/images/user-4.png';
import PROFILE5 from '../assets/images/user-svg-icon.svg';
import ARROW_SVG from '../assets/images/svg/arrow.svg';
import ARROW_RIGHT from '../assets/images/svg/arrow-right.svg';
import CONTACT_SVG from '../assets/images/svg/contact-us.svg';
import WHITE_LOGO from '../assets/images/logo-white.png';
import CHAT_LOGO from '../assets/images/chat_logo.png';
import DISAPPEAR_ICON from '../assets/images/disappear-icon.png';
import WINDOW_SVG from '../assets/images/svg/window.svg';
import MOBILE_SVG from '../assets/images/svg/mobile.svg';
import OVAL_SVG from '../assets/images/svg/Oval.svg';
import ICON from '../assets/images/Icon.png';
import THREE_DOT from '../assets/images/svg/three-dots.svg'
import DELETE from '../assets/images/svg/delete.svg'
import BACK_BUTTON_SVG from '../assets/images/svg/back_btn.svg';
import VISA_IMG from '../assets/images/VISA.png';
import L1_SVG from '../assets/images/svg/L1.svg';
import W1_IMG from '../assets/images/w1.png';
import BOX_IMG from '../assets/images/box.png';
import BOX_IMG2 from '../assets/images/box2.png';
import MESSAGE_IMG from '../assets/images/message.png';
import HEART_IMG from '../assets/images/heart1.png';
import HEARTSHOW_IMG from '../assets/images/heart.png';
import FAV_IMG from '../assets/images/fav1.png';
import DOWNLOAD_SVG from '../assets/images/svg/downloads.svg';
import MOVE_SVG from '../assets/images/svg/move.svg';
import CLOSE_WHITE from '../assets/images/svg/close-white.svg';
import IMAGE_01 from '../assets/images/cevaheer-icon-chat.png';
import C1_PNG from '../assets/images/c1.png';
import N1_PNG from '../assets/images/n1.png';
import COLOR_STONE_THUMB from '../assets/images/color-stone-thumb.png';
import ADD_PNG from '../assets/images/add.png';
import REMOVE_PNG from '../assets/images/remove.png';
import DEGREE_PNG from '../assets/images/360.png';
import COLOR_STONE_PRO_PNG from '../assets/images/color-stone-pro.png';
import COLOR_STONE_LARGE_PNG from '../assets/images/color-stone-large.png';
import EDIT_PNG from '../assets/images/edit.png';
import COMPARE_IMG from '../assets/images/svg/compare.svg';
import NO_IMAGE_JPG from '../assets/images/no_image.jpg';
import DOWNLOAD from '../assets/images/download.png';
import COMMENTSVG from '../assets/images/svg/Figma Icons/comment.svg';
import EmptyPageImage from '../assets/images/404-img.png';
import VideoDefaultThumb from '../assets/images/video-thumb.jpg';

import bannerIMG from '../assets/images/NewHome/bannerIMG.png';
import home_video from '../assets/images/NewHome/home_video.mp4';
import welcome_img from '../assets/images/NewHome/welcome_img.png';
import newICOn1 from '../assets/images/NewHome/icon-1.png';
import newICOn2 from '../assets/images/NewHome/icon-2.png';
import newICOn3 from '../assets/images/NewHome/icon-3.png';
import newICOn4 from '../assets/images/NewHome/icon-4.png';
import newICOn5 from '../assets/images/NewHome/icon-5.png';
import newICOn6 from '../assets/images/NewHome/icon-6.png';
import newICOn7 from '../assets/images/NewHome/icon-7.png';
import newICOn8 from '../assets/images/NewHome/icon-8.png';
import newICOn9 from '../assets/images/NewHome/icon-9.png';
import newICOn10 from '../assets/images/NewHome/icon-10.png';
import newICOn11 from '../assets/images/NewHome/icon-11.png';
import newICOn12 from '../assets/images/NewHome/icon-12.png';
import TrustIMG1 from '../assets/images/NewHome/TrustIMG1.png';
import TrustIMG2 from '../assets/images/NewHome/TrustIMG2.png';
import TrustIMG3 from '../assets/images/NewHome/TrustIMG3.png';
import arrowROund from '../assets/images/NewHome/arrowROund.png';
import Competitive_leftIMG from '../assets/images/NewHome/Competitive_leftIMG.png';

import ONEstar from '../assets/images/NewHome/1star-r.svg';
import twostar from '../assets/images/NewHome/2star-r.svg';
import ThreeStar from '../assets/images/NewHome/3star-r.svg';
//star image for star rating
import star_1 from '../assets/images/NewHome/1star.svg';
import star_2 from '../assets/images/NewHome/2star.svg';
import star_3 from '../assets/images/NewHome/3star.svg';
import star_4 from '../assets/images/NewHome/4star.svg';
import star_5 from '../assets/images/NewHome/5star.svg';
import ratingIMG from '../assets/images/NewHome/rating-img.png';
import userPHot from '../assets/images/NewHome/userPHot.png';
import calliCon from '../assets/images/NewHome/calliCon.svg';
import earth from '../assets/images/NewHome/earth.svg';
import call from '../assets/images/NewHome/call.svg';

//dimonds
import PRO_THUMB from '../assets/images/pro-thumb.png';
import PRO_PNG from '../assets/images/pro.png';
import PRO_LARGE_PNG from '../assets/images/pro-large.png';

import APP_STORE from '../assets/images/APPStore.png';
import GP_STORE from '../assets/images/GPStore.png';

//excelTemplate
import WATCH_TEMPLATE from '../assets/excelTemplate/Watches_Upload_Template.xls';
import DIAMOND_TEMPLATE from '../assets/excelTemplate/Diamond_Upload_Template.xls';
import PARCEL_TEMPLATE from '../assets/excelTemplate/Parcel_Upload_Template.xls';
import COLOR_STONE_TEMPLATE from '../assets/excelTemplate/ColorStones_Upload_Template.xls';
import WEDDING_BAND_TEMPLATE from '../assets/excelTemplate/WeddingBands_Upload_Template.xls';
import JEWELRY_TEMPLATE from '../assets/excelTemplate/Jewelry_Upload_Template.xls';



import i1Img from '../assets/images/i1.svg';
import i2Img from '../assets/images/i2.png';
import i3Img from '../assets/images/i3.png';
import i4Img from '../assets/images/i4.svg';
import i5Img from '../assets/images/i5.svg';
import i6Img from '../assets/images/i6.svg';
import i7Img from '../assets/images/i7.svg';
import i8Img from '../assets/images/i8.svg';
import offerImg from '../assets/images/offer.svg';
import filterIcon from '../assets/images/filter-icon.svg';
import playIcon from '../assets/images/play-icon.png';
import docIcon from '../assets/images/doc-icon.png';
import imgIcon from '../assets/images/img-icon.png';
import searchIcon from '../assets/images/search-icon.svg';
import diamondHeader from '../assets/images/diamondHeader.svg';



export const IMAGES = {
    WATCH_TEMPLATE: WATCH_TEMPLATE,
    DIAMOND_TEMPLATE: DIAMOND_TEMPLATE,
    PARCEL_TEMPLATE: PARCEL_TEMPLATE,
    COLOR_STONE_TEMPLATE: COLOR_STONE_TEMPLATE,
    WEDDING_BAND_TEMPLATE: WEDDING_BAND_TEMPLATE,
    JEWELRY_TEMPLATE: JEWELRY_TEMPLATE,

    LOGO: LOGO,
    VIEW_SVG: VIEW_SVG,
    VIEW_CLOSE:VIEW_CLOSE,
    LOGO_BLACK: LOGO_BLACK,
    LOGO_BLUE: LOGO_BLUE,
    WHITE_LOGO: WHITE_LOGO,
    CHECK_SVG: CHECK_SVG,
    BROWSER_IMAGE: BROWSER_IMAGE,
    FACEBOOK_IMAGE: FACEBOOK_IMAGE,
    INSTAGRAM_IMAGE: INSTAGRAM_IMAGE,
    TWITTER_IMAGE: TWITTER_IMAGE,
    LINKEDIN_IMAGE: LINKEDIN_IMAGE,
    NO_IMAGE: NO_IMAGE,
    LONG_ARROW: LONG_ARROW,
    AVATAR: AVATAR,
    PROFILE: PROFILE,
    PROFILE1: PROFILE1,
    PROFILE2: PROFILE2,
    PROFILE3: PROFILE3,
    PROFILE4: PROFILE4,
    PROFILE5: PROFILE5,
    PLAN_ICON: PLAN_ICON,
    SEARCH_SVG: SEARCH_SVG,
    EMAIL_SVG: EMAIL_SVG,
    HEART_SVG: HEART_SVG,
    PROFILE_IMG: PROFILE_IMG,
    ARROW_SVG: ARROW_SVG,
    ARROW_RIGHT: ARROW_RIGHT,
    CONTACT_SVG: CONTACT_SVG,
    WINDOW_SVG: WINDOW_SVG,
    MOBILE_SVG: MOBILE_SVG,
    OVAL_SVG: OVAL_SVG,
    ICON: ICON,
    BACK_BUTTON_SVG: BACK_BUTTON_SVG,
    VISA_IMG: VISA_IMG,
    L1_SVG: L1_SVG,
    W1_IMG: W1_IMG,
    BOX_IMG: BOX_IMG,
    BOX_IMG2: BOX_IMG2,
    MESSAGE_IMG: MESSAGE_IMG,
    HEART_IMG: HEART_IMG,
    FAV_IMG: FAV_IMG,
    DOWNLOAD_SVG: DOWNLOAD_SVG,
    MOVE_SVG: MOVE_SVG,
    CLOSE_WHITE: CLOSE_WHITE,
    IMAGE_01: IMAGE_01,
    C1_PNG: C1_PNG,
    COLOR_STONE_THUMB: COLOR_STONE_THUMB,
    ADD_PNG: ADD_PNG,
    REMOVE_PNG: REMOVE_PNG,
    DEGREE_PNG: DEGREE_PNG,
    COLOR_STONE_PRO_PNG: COLOR_STONE_PRO_PNG,
    COLOR_STONE_LARGE_PNG: COLOR_STONE_LARGE_PNG,
    PRO_THUMB: PRO_THUMB,
    PRO_PNG: PRO_PNG,
    PRO_LARGE_PNG: PRO_LARGE_PNG,
    GP_STORE: GP_STORE,
    APP_STORE: APP_STORE,
    THREE_DOT: THREE_DOT,
    DELETE: DELETE,
    EDIT_PNG: EDIT_PNG,
    N1_PNG: N1_PNG,
    HEARTSHOW_IMG: HEARTSHOW_IMG,
    COMPARE_IMG: COMPARE_IMG.anchor,
    NO_IMAGE_JPG: NO_IMAGE_JPG,
    DOWNLOAD: DOWNLOAD,
    EmptyPageImage: EmptyPageImage,
    COMMENTSVG: COMMENTSVG,
    VideoDefaultThumb: VideoDefaultThumb,
    CHAT_LOGO: CHAT_LOGO,
    DISAPPEAR_ICON: DISAPPEAR_ICON,


    bannerIMG: bannerIMG,
    home_video: home_video,
    welcome_img: welcome_img,
    newICOn1: newICOn1,
    newICOn2: newICOn2,
    newICOn3: newICOn3,
    newICOn4: newICOn4,
    newICOn5: newICOn5,
    newICOn6: newICOn6,
    newICOn7: newICOn7,
    newICOn8: newICOn8,
    newICOn9: newICOn9,
    newICOn10: newICOn10,
    newICOn11: newICOn11,
    newICOn12: newICOn12,
    TrustIMG1: TrustIMG1,
    TrustIMG2: TrustIMG2,
    TrustIMG3: TrustIMG3,
    arrowROund: arrowROund,
    round_star_1: ONEstar,
    round_star_2: twostar,
    round_star_3: ThreeStar,
    star_1: star_1,
    star_2: star_2,
    star_3: star_3,
    star_4: star_4,
    star_5: star_5,
    Competitive_leftIMG: Competitive_leftIMG,
    ratingIMG: ratingIMG,
    userPHot: userPHot,
    calliCon: calliCon,
    earth: earth,
    call: call,


    i1Img: i1Img,
    i2Img: i2Img,
    i3Img: i3Img,
    i4Img: i4Img,
    i5Img: i5Img,
    i6Img: i6Img,
    i7Img: i7Img,
    i8Img: i8Img,
    offerImg: offerImg,
    filterIcon: filterIcon,
    playIcon: playIcon,
    docIcon: docIcon,
    imgIcon: imgIcon,
    searchIcon: searchIcon,
    diamondHeader:diamondHeader


}
export const JEWELER_ROLE = 1
export const SUPPLIER_ROLE = 2
// export const JEWELER_SMALL = 10
// export const JEWELER_SMALL_SEARCHES = 20
export const JEWELER_SMALL = 22
export const JEWELER_SMALL_TEXT = 33
export const SMALL_JEWELER_PLAN_IDS = [22, 33, 40]
export const MAX_PLAN_IDS = [39, 36, 28, 25, 46, 43]
export const FREEMIUM_PLAN_ID = 32
export const JEWELER_SMALL_SEARCHES = 30

export const isSmallJewelerPlan = (planId) => SMALL_JEWELER_PLAN_IDS.includes(Number(planId))
export const isMaxPlan = (planId) => MAX_PLAN_IDS.includes(Number(planId))
export const FREEMIUM_SEARCHES = 2

export const FINISH_COMB = [[1], [0, 1], [0, 1, 2], [0, 1, 2, 3]]
export const SEARCH_LIMIT_MSG = 'Your monthly search limit is finished. Upgrade and enjoy unlimited search.';
export const currentLanguage = localStorage.getItem("lang");

// export const FEATURE_RESTRICTION = currentLanguage == "en" ? "To use this feature, you need to subscribe to a plan" : "Bu özelliği kullanmak için bir plana abone olmanız gerekir";
export const FEATURE_RESTRICTION = currentLanguage === "en" ? "To use this section, please update your plan. Or contact sales team 530 235 9078." : "Bu bölümü kullanmak için lütfen paketinizi yükseltin. Veya satış ekibiyle bu numaradan 530 235 9078 iletişime geçiniz.";
export const FREE_PLAN_FEATURE = currentLanguage === "en" ? "You will get 2 free searches a week. To make new searches, please choose one of the monthly or yearly plans below. Or contact sales team 530 235 9078." : "Haftada 2 ücretsiz arama hakkınız vardır. Daha fazla arama yapmak için lütfen aşağıdaki aylık veya yıllık planlardan birini seçiniz. Veya satış ekibiyle bu numaradan 530 235 9078 iletişime geçiniz.";
export const NEW_FREE_PLAN_FEATURE = currentLanguage === "en" ? "Enjoy unlimited searches for the first two weeks! After that, you'll receive 2 free searches per week. To continue searching beyond that, please choose one of our monthly or yearly plans below. For any assistance, feel free to contact our sales team at 530-235-9078." : "İlk iki hafta boyunca sınırsız aramanın keyfini çıkarın! Bundan sonra, haftada 2 ücretsiz arama alacaksınız. Bundan sonra aramaya devam etmek için lütfen aşağıdaki aylık veya yıllık planlarımızdan birini seçin. Herhangi bir yardım için, 530-235-9078 numaralı telefondan satış ekibimizle iletişime geçmekten çekinmeyin."

export const NEW_FREE_DOWNGRADE_FEATURE = currentLanguage === "en" ? "**Enjoy our Freemium plan with two free searches per week**. Need more? Upgrade to a **monthly or yearly plan** for expanded access and exclusive diamond sourcing benefits. For questions or assistance, our sales team is here to help—just call **530-235-9078**. **Upgrade today and discover more!** " : "**Haftada 2 ücretsiz arama bizden.**Ücretsiz planımızın keyfini çıkartın. **Daha fazlasını ister misiniz?** Sınırsız erişim ve premium özellikler için **aylık/yıllık planlarımıza** yükseltme yapabilirsiniz. **Sorularınız mı var?** Satış ekibimiz size yardımcı olmaktan mutluluk duyar: **530-235-9078. **Sınırları kaldırın, aramaya devam edin!** *Daha detaylı bilgi veya özel teklifler için bizimle iletişime geçebilirsiniz.*"

export const UNLIMITED_SEARCH = currentLanguage === "en" ? "Unlimited Search" : "Sınırsız Arama"

// YOUR SEARCH LIMIT IS EXHAUSTED. UPGRADE AND ENJOY UNLIMITED SEARCH.